// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/backoffice/service/newprofiles/v1/new_profiles.proto (package gdx.backoffice.service.newprofiles.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ProfileGender } from "../../../web/users/v1/profile_pb.js";
import { Feedback, Outcome, Reason } from "../../decision/v1/decision_pb.js";

/**
 * Possible actor types to perform actions on profile.
 *
 * @generated from enum gdx.backoffice.service.newprofiles.v1.ActorType
 */
export enum ActorType {
  /**
   * @generated from enum value: ACTOR_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: ACTOR_TYPE_MODERATOR = 1;
   */
  MODERATOR = 1,

  /**
   * @generated from enum value: ACTOR_TYPE_AUTO = 2;
   */
  AUTO = 2,

  /**
   * @generated from enum value: ACTOR_TYPE_USER = 3;
   */
  USER = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ActorType)
proto3.util.setEnumType(ActorType, "gdx.backoffice.service.newprofiles.v1.ActorType", [
  { no: 0, name: "ACTOR_TYPE_INVALID" },
  { no: 1, name: "ACTOR_TYPE_MODERATOR" },
  { no: 2, name: "ACTOR_TYPE_AUTO" },
  { no: 3, name: "ACTOR_TYPE_USER" },
]);

/**
 * Structure of profile message.
 *
 * @generated from message gdx.backoffice.service.newprofiles.v1.Profile
 */
export class Profile extends Message<Profile> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string full_name = 2;
   */
  fullName = "";

  /**
   * @generated from field: string photo_id = 3;
   */
  photoId = "";

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileGender gender = 4;
   */
  gender = ProfileGender.INVALID;

  /**
   * @generated from field: uint32 age = 5;
   */
  age = 0;

  constructor(data?: PartialMessage<Profile>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.service.newprofiles.v1.Profile";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 5, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Profile {
    return new Profile().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Profile {
    return new Profile().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Profile {
    return new Profile().fromJsonString(jsonString, options);
  }

  static equals(a: Profile | PlainMessage<Profile> | undefined, b: Profile | PlainMessage<Profile> | undefined): boolean {
    return proto3.util.equals(Profile, a, b);
  }
}

/**
 * Structure of moderation result message.
 *
 * @generated from message gdx.backoffice.service.newprofiles.v1.Result
 */
export class Result extends Message<Result> {
  /**
   * @generated from field: gdx.backoffice.service.decision.v1.Outcome outcome = 1;
   */
  outcome = Outcome.INVALID;

  /**
   * @generated from field: repeated gdx.backoffice.service.decision.v1.Reason reasons = 2;
   */
  reasons: Reason[] = [];

  /**
   * @generated from field: repeated gdx.backoffice.service.decision.v1.Feedback feedback = 3;
   */
  feedback: Feedback[] = [];

  constructor(data?: PartialMessage<Result>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.service.newprofiles.v1.Result";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "outcome", kind: "enum", T: proto3.getEnumType(Outcome) },
    { no: 2, name: "reasons", kind: "message", T: Reason, repeated: true },
    { no: 3, name: "feedback", kind: "message", T: Feedback, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Result {
    return new Result().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Result {
    return new Result().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Result {
    return new Result().fromJsonString(jsonString, options);
  }

  static equals(a: Result | PlainMessage<Result> | undefined, b: Result | PlainMessage<Result> | undefined): boolean {
    return proto3.util.equals(Result, a, b);
  }
}

